import { render, staticRenderFns } from "./TabGeneralDetails.vue?vue&type=template&id=5f0de890&scoped=true&"
import script from "./TabGeneralDetails.vue?vue&type=script&lang=js&"
export * from "./TabGeneralDetails.vue?vue&type=script&lang=js&"
import style0 from "./TabGeneralDetails.vue?vue&type=style&index=0&id=5f0de890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0de890",
  null
  
)

export default component.exports